import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as moment from 'moment'; // Asegúrate de que moment esté importado si lo usas para formateo

// Define la interfaz para la estructura del item que espera NotificationCardComponent
// Esta interfaz refleja cómo EmpHomeComponent mapea los datos de la API
export interface NotificationItem {
  title: string;
  description: string; // La descripción de la API se mapea aquí
  date: string;        // La fecha original de la API
  type: string;        // El 'origin' de la API se mapea a 'type' (ej: 'credentials', 'vacations')
  
  // Propiedades opcionales que no siempre están presentes en la nueva API,
  // pero que el template podría intentar mostrar.
  // Se marcan como opcionales para evitar errores de tipo.
  duration?: number; // Este campo ya no se usa para la descripción de la API
  userData?: { name: string; image: string };
  certification?: string;
  address?: string;
  institutionName?: string;
  institutionImg?: string;
  start?: { active: boolean; dateStart: string; dateEnd: string }; // Para compatibilidad con el formato de fecha anterior
}

@Component({
  selector: 'app-notification-card',
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.scss']
})
export class NotificationCardComponent implements OnInit {
  public img: string = '';
  public imgInstitution: string = '';
  public apiUrl = environment.apiUrl;

  @Input() item!: NotificationItem; // Usa la nueva interfaz para el Input

  // Mapeo para los nuevos tipos de origen de la API
  typeName: { [key: string]: string } = {
    'credentials': 'Credencial',
    'vacations': 'Vacaciones',
    // Puedes añadir más tipos de origen de la API aquí si es necesario
    // 'ONLINE': 'En línea', // Elimina estos si no son relevantes para las notificaciones
    // 'INSITE': 'Presencial',
    // 'HYBRID': 'Híbrido'
  };

  constructor() { }

  ngOnInit(): void {
    // Estas asignaciones ahora dependerán de si 'userData' o 'institutionImg' existen en el 'item'
    // Si no existen, 'img' e 'imgInstitution' permanecerán como cadenas vacías,
    // lo que se manejará en el HTML para no mostrar imágenes rotas.
    this.imgInstitution = (this.item.institutionImg) ? (`${this.apiUrl}${this.item.institutionImg}`):"";
    this.img = (this.item.userData?.image) ? (`${this.apiUrl}${this.item.userData.image}`):"";
  }
}